import React, { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { applyUtmsToHubspotForm } from "@src/helpers/utms";

interface HubspotAiChallengeFormProps {
  region?: string;
  portalId?: string;
  formId: string;
  successCallback?(form: any): void;
  rawCSSStyles?: {
    [key: string]: {
      [key: string]: any;
    };
  };
  hideUntilLoaded?: boolean;
}

const HubspotAiChallengeForm: FC<HubspotAiChallengeFormProps> = ({
  region = "na1",
  portalId = "21503852",
  formId,
  successCallback,
  rawCSSStyles = {},
  hideUntilLoaded = false,
}) => {
  const [loaded, setLoaded] = useState(!hideUntilLoaded);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          target: "#hubspotForm-aichallenge",
          onFormReady: ($form: HTMLFormElement) => {
            applyUtmsToHubspotForm($form);

            for (const key in rawCSSStyles) {
              try {
                if (key === "$form") {
                  for (const cssKey in rawCSSStyles[key]) {
                    $form.style[cssKey as any] = rawCSSStyles[key][cssKey];
                  }
                } else {
                  const els = $form.querySelectorAll(key);
                  els.forEach((el: Element) => {
                    for (const cssKey in rawCSSStyles[key]) {
                      (el as HTMLElement).style[cssKey as any] =
                        rawCSSStyles[key][cssKey];
                    }
                  });
                }
              } catch (e) {
                console.error(e);
              }
            }

            setLoaded(true);
          },
        });
      }
    });
  }, []);

  return (
    <Box
      id="hubspotForm-aichallenge"
      sx={{
        opacity: loaded ? 1 : 0,
        width: "100%",
        maxWidth: "720px",
        marginX: "auto",
      }}
    />
  );
};

export default HubspotAiChallengeForm;
